import { render, staticRenderFns } from "./ReassignHistoryDrawer.vue?vue&type=template&id=1fb5ba18"
import script from "./ReassignHistoryDrawer.vue?vue&type=script&lang=js"
export * from "./ReassignHistoryDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports